import React from 'react';
import { T, fontBody, fontMono } from '../tokens';

export default function TemplateCardStats({ template }) {
  return (
    <div style={{ display: 'flex', gap: 14, alignItems: 'center', minWidth: 0, overflow: 'hidden' }}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 4, minWidth: 0 }}>
        <span style={{ fontFamily: fontMono, fontSize: 15, fontWeight: 600, color: T.ink }}>{template.triggered ?? 0}</span>
        <span style={{ fontFamily: fontBody, fontSize: 12, color: T.slateLight }}>triggered</span>
      </div>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 4, minWidth: 0 }}>
        <span style={{ fontFamily: fontMono, fontSize: 15, fontWeight: 600, color: T.coral }}>{template.leads ?? 0}</span>
        <span style={{ fontFamily: fontBody, fontSize: 12, color: T.slateLight }}>leads</span>
      </div>
    </div>
  );
}
